var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.warningZone)?_c('small',{staticClass:"float-right text-danger p-1"},[_vm._v("Você será desconectado em breve")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }